import React from 'react';
import { Button, Typography, Box } from '@mui/material';
import { InfoCard } from '@innovyze/stylovyze';
import { useDispatch, useSelector } from 'react-redux';
import {
	regenerateAssetTiles,
	regenerateSensorTiles,
	regenerateInspectionTiles,
} from '@Actions/mapManagement';
import { NamespacedStoreState } from '@Types/store.types';

const MapManagement: React.FC = () => {
	const dispatch = useDispatch();
	const {
		isAssetGenerationInProgress,
		isSensorGenerationInProgress,
		isInspectionGenerationInProgress,
	} = useSelector(
		(state: NamespacedStoreState) =>
			state.entitlements.mapManagement.tileData,
	);

	const handleRetileAssets = async () => {
		dispatch(regenerateAssetTiles());
	};

	const handleRetileSensors = async () => {
		dispatch(regenerateSensorTiles());
	};

	const handleRetileInspections = async () => {
		dispatch(regenerateInspectionTiles());
	};

	return (
		<InfoCard title="Tile Data">
			<Typography>
				Trigger a job to regenerate all map tiles. This will take some
				time.
			</Typography>
			<Box mt={2}>
				<Button
					variant="contained"
					color="primary"
					onClick={handleRetileAssets}
					disabled={isAssetGenerationInProgress}>
					{isAssetGenerationInProgress
						? 'Regenerating...'
						: 'Regenerate asset tiles'}
				</Button>
			</Box>
			<Box mt={2}>
				<Button
					variant="contained"
					color="primary"
					onClick={handleRetileSensors}
					disabled={isSensorGenerationInProgress}>
					{isSensorGenerationInProgress
						? 'Regenerating...'
						: 'Regenerate sensor tiles'}
				</Button>
			</Box>
			<Box mt={2}>
				<Button
					variant="contained"
					color="primary"
					onClick={handleRetileInspections}
					disabled={isInspectionGenerationInProgress}>
					{isInspectionGenerationInProgress
						? 'Regenerating...'
						: 'Regenerate inspection tiles'}
				</Button>
			</Box>
		</InfoCard>
	);
};

export default MapManagement;
